/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbSharedTopTileController_viewer = {|
  +disablePriceTiles: ?boolean;
  +onApprovalEnabled: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedTopTileController_viewer",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "disablePriceTiles",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "disablePriceTiles",
          "type": "String!"
        }
      ],
      "name": "isEnabled",
      "storageKey": "isEnabled{\"key\":\"disablePriceTiles\"}"
    },
    {
      "kind": "ScalarField",
      "alias": "onApprovalEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "onApprovalEnabled",
          "type": "String!"
        }
      ],
      "name": "isEnabled",
      "storageKey": "isEnabled{\"key\":\"onApprovalEnabled\"}"
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
